import { defineFcm } from '../shared/factory';

export const FCM_CORGI_SESSION_LOGGING_VERBOSE = defineFcm('corgi_session_logging_verbose')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		supportedGroups: { global: true },
		context: 'Session handling',
		description: 'Enables verbose diagnostic logging for session handling (e.g. expired session details).',
	});
